export const LOGO_URL = '/images/logovsap120.png'
